import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AcceptanceSubmittedThankyouComponent } from 'src/app/views/partials/shared/dialogs/acceptance-submitted-thankyou/acceptance-submitted-thankyou.component';
import { DenyApplicationComponent } from 'src/app/views/partials/shared/dialogs/deny-application-dialog/deny-application-dialog.component';
import { RequestApplicantResubmitComponent } from 'src/app/views/partials/shared/dialogs/request-applicant-resubmit-dialog/request-applicant-resubmit-dialog.component';
import { ViewCertDialogComponent } from 'src/app/views/partials/shared/dialogs/view-cert-dialog/view-cert-dialog.component';
import { EligibilityRulesDialogComponent } from 'src/app/views/partials/shared/dialogs/eligibility-rules-dialog/eligibility-rules-dialog.component';
import { ApplicationWizard } from '../models/application-wizard.model';
import { MobileViewDialogComponent } from 'src/app/views/partials/shared/dialogs/mobile-view-dialog/mobile-view-dialog.component';
import { LoginTermAndConditionComponent } from 'src/app/views/partials/shared/dialogs/login-term-and-condition/login-term-and-condition.component';
import { AppProgressDialogComponent } from 'src/app/views/partials/shared/dialogs/app-progress-dialog/app-progress-dialog.component';
import { RoleArtifact } from '../models/role-artifacts.model';
import { DeleteApplicationDialogComponent } from 'src/app/views/partials/shared/dialogs/delete-application-dialog/delete-application-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    public dialog: MatDialog,
  ) { }

  viewCertificates(alsdeId: string, name?: string) {
    let data: any = {alsdeId, name};
    return this.dialog.open(ViewCertDialogComponent, {
      data, width: '100%'
    });
  }
  requestApplicantResubmit(appId: string) {
    let data: any = {appId};
    return this.dialog.open(RequestApplicantResubmitComponent, {
      data, width: '500px'
    });
  }
  denyApplication(appId: string) {
    let data: any = {appId};
    return this.dialog.open(DenyApplicationComponent, {
      data, width: '500px'
    });
  }

  deleteApplication(appId: string) {
    let data: any = {appId};
    return this.dialog.open(DeleteApplicationDialogComponent, {
      data, width: '500px'
    });
  }

  viewCertWizController(addWizObj:ApplicationWizard, isApp:boolean) {
    let config = {
      key:"CertWizControllerComponent",
      data:{
        addWizObj,
        isApp,
      }
    };
    return this.dialog.open(MobileViewDialogComponent, {
      data: config, 
      width: '100%'
    });
  }

  viewAppWizardHeader(configData:any) {
    let config = {
      key:"AppWizardHeaderComponent",
      data:configData
    };
    return this.dialog.open(MobileViewDialogComponent, {
      data: config, 
      width: '100%'
    });
  }
  acceptanceSubmittedThankyou(type: string, appId: string) {
    return this.dialog.open(AcceptanceSubmittedThankyouComponent, {
      width: '500px',
      data: { appId }
    });
  }
  
  loginTermCondition() {
    return this.dialog.open(LoginTermAndConditionComponent, {
      width: '100%'
    });
  }

  viewEligibilityRules(record: any, ruleStatuses: any[]) {
    return this.dialog.open(EligibilityRulesDialogComponent, {
      data: { record, ruleStatuses },
      width: '700px',
      maxWidth: '90vw',
      maxHeight: '80vh',
      // Scope this dialog's container styling to itself so its ::ng-deep overrides
      // don't leak globally onto other dialogs (e.g. the cert dialog header).
      panelClass: 'eligibility-rules-dialog'
    });
  }

  appProgress(roleArtifacts: RoleArtifact[]) {
    return this.dialog.open(AppProgressDialogComponent, {
      data: roleArtifacts, 
      panelClass: 'no-padding-dialog'
    });
  }
}
